<template lang="pug">
div.container
  div.body
    div
      div.logo
        img( src="@/assets/kiddiecoinLogo.svg")
      div.header
        span.text-23-b Поддержка KiddieCoin
      div.password-text.text-16
        div.mb-2 Добро пожаловать в центр поддержки приложения KiddieCoin.
        div.mb-2 Если у вас возникли вопросы по работе приложения, начислению заданий, баллов или настройкам профиля — мы готовы помочь.
        div.mb-2 Связаться с нами
        div.mb-2 Напишите нам на электронную почту:
        div.mb-2 isa06022025@gmail.com
        div.mb-2 Мы отвечаем в течение 24 часов в рабочие дни.
        div.mb-2 Частые вопросы
        div.mb-2 Как ребёнок получает задания?
        div.mb-2 Родитель создаёт задание, указывает сумму вознаграждения и срок выполнения. После выполнения ребёнок получает условные средства.
        div.mb-2 Что делать, если задание не засчиталось?
        div.mb-2 Проверьте, сохранилась информация  Если проблема сохраняется — напишите нам.
        div.mb-2 Проверьте правильность введённого номера телефона или электронной почты. Также проверьте папку «Спам».
        div.mb-2 Как восстановить доступ?
        div.mb-2 Используйте функцию «Забыли пароль?» на экране входа или обратитесь в поддержку.
        div.mb-2 Безопасность
        div.mb-2 Мы внимательно относимся к защите данных пользователей. Если вы обнаружили возможную уязвимость или ошибку — пожалуйста, сообщите нам.
</template>

<script>
export default{
  name:"UserRegistration",
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.body {
  width: auto;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 16px 0px 16px;
}
.logo {
  margin: 0px 0px 10px 0px;
}
.header {
  text-align: center;
  margin: 30px 0;
}
.password-text {
  text-align: start;
}
.back-button {
  display: flex;
}
</style>